<template>
  <div class="font-bold ml-2">
    Edit mode
    <toggle-button
      :value="isPPTEditMode"
      :width="35"
      :height="20"
      class="mb-0 ml-2 mr-2"
      :color="{
        checked: '#6A1EBB',
        unchecked: '#D3D7E1'
      }"
      @change="onChangeEditMode"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      isPPTEditMode: (state) => state.isPPTEditMode,
    }),
  },
  methods: {
    ...mapActions(['setEditMode']),

    onChangeEditMode(input) {
      this.setEditMode(input.value)
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-trigger-btn {
  @apply relative top-2 items-center px-1.5 xl:px-2 pt-2 pb-6;
  @apply md:flex;
  // only apply transition to color. Prevent wierd background flicker when applying --active class
  transition-property: color;

  &--active {
    @apply z-20 rounded-t-md text-primary-100;
    &:not(.share-v2){
      @apply bg-base-0
    }
  }
}
</style>
